var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 789 362",
    style: {
      enableBackground: "new 0 0 789 362"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2B9BC6;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.3,203.9v20.8H140V86.8h38.4v139.8c0,9.9-3.5,18.4-10.6,25.5c-7.1,7.1-15.6,10.6-25.5,10.6H38.6 c-10.1,0-18.7-3.5-25.7-10.5c-7-7-10.5-15.6-10.5-25.7v-22.7H40.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.4,86.8H345c9.9,0,18.4,3.5,25.5,10.6c7.1,7.1,10.6,15.6,10.6,25.5v103.6c0,9.9-3.5,18.4-10.6,25.5 c-7.1,7.1-15.6,10.6-25.5,10.6H241.4c-10.1,0-18.7-3.5-25.7-10.5c-7-7-10.5-15.6-10.5-25.7V123c0-10.1,3.5-18.7,10.5-25.7 C222.8,90.3,231.3,86.8,241.4,86.8z M243.1,124.9v99.7h99.7v-99.7H243.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M577.9,123v33c0,4.6-0.6,8.3-1.7,11.2c5.7,7.2,8.6,14.8,8.6,23v36.4c0,9.9-3.5,18.4-10.6,25.5 c-7.1,7.1-15.7,10.6-25.8,10.6H408.8V86.8h132.9c9.9,0,18.4,3.5,25.5,10.6C574.4,104.5,577.9,113,577.9,123z M446.7,124.9v29.3 h92.9v-29.3H446.7z M446.7,192.4v32.3h99.7v-32.3H446.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M786.1,123v16.4h-38.4v-14.4H648v30.8h101.9c9.9,0,18.4,3.5,25.5,10.6c7.1,7.1,10.6,15.6,10.6,25.5v34.7 c0,9.9-3.5,18.4-10.6,25.5c-7.1,7.1-15.6,10.6-25.5,10.6H646.3c-9.9,0-18.4-3.5-25.5-10.5c-7.1-7-10.6-15.6-10.6-25.7v-16.4H648 v14.4h99.7v-30.8H646.3c-9.9,0-18.4-3.5-25.5-10.5c-7.1-7-10.6-15.6-10.6-25.7V123c0-10.1,3.5-18.7,10.6-25.7 c7.1-7,15.6-10.5,25.5-10.5h103.6c9.9,0,18.4,3.5,25.5,10.6C782.6,104.5,786.1,113,786.1,123z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsLogo);
export default __webpack_public_path__ + "static/media/JOBSLogo.d6e4d1f7e0d619ff9b6ca222b4bda5bd.svg";
export { ForwardRef as ReactComponent };